import React, { useEffect, useState } from "react";
import cx from "classnames";

import styles from "./variant-options.module.css";

export const VariantOptions = ({
  activeVariantId,
  options,
  liveVariants,
  variants,
  onVariantSelect,
  isFootwear,
}: {
  activeVariantId: number;
  liveVariants: [any];
  options: [any];
  variants: any;
  onVariantSelect: (
    e: React.FormEvent,
    variantId: number,
    variantAvailable: boolean
  ) => void;
  isFootwear: boolean;
}) => {
  return (
    <div
      className={cx(
        styles.variantOptions,
        isFootwear ? styles.shoeOptions : ""
      )}
    >
      {liveVariants?.length > 0 &&
        variants &&
        variants.map((variant: any, index: number) => {
          const { variantId } = variant.content.shopify;
          const liveVariant = liveVariants.find(
            (variant) => variant.cleanId === variantId
          );
          const liveVariantAvailable = liveVariant?.available as boolean;

          const parsedTitle = liveVariant.title.split("/")[1]
            ? liveVariant.title.split("/")[1].trim()
            : liveVariant.title;

          return (
            <button
              className={cx(
                styles.variantButton,
                isFootwear ? styles.shoeVariantButton : "",
                isFootwear ? styles.shoeVariantButtonBorder : "",
                activeVariantId === variantId ? styles.active : "",
                liveVariantAvailable ? "" : styles.disabled
              )}
              key={variantId}
              onClick={(e) =>
                onVariantSelect(e, variantId, liveVariantAvailable)
              }
            >
              <span>{parsedTitle}</span>
            </button>
          );
        })}
    </div>
  );
};
